import request from '@/utils/request'

// 下拉
export function materialsSchemeListSelectDataApi(data) {
  return request({
    url: 'web/materialsScheme/listSelectData',
    method: 'post',
    data
  })
}

// 获取明细
export function initMaterialsSchemeDetailApi(data) {
  return request({
    url: 'web/materialsScheme/initMaterialsSchemeDetail',
    method: 'post',
    data
  })
}

// 获取待入库的物料方案
export function findSchemeByTaskCreateIndepotApi(data) {
  return request({
    url: 'web/materialsScheme/findSchemeByTaskCreateIndepot',
    method: 'post',
    data
  })
}

// 获取待入库的物料数量
export function countTodoInDepotApi(data) {
  return request({
    url: 'web/materialsScheme/countTodoInDepot',
    method: 'post',
    data
  })
}

// 查询待申请物料需求的方案物料清單
export function listTodoApplyMaterialsApi(data) {
  return request({
    url: 'web/materialsScheme/listTodoApplyMaterials',
    method: 'post',
    data
  })
}

// 明细列表
export function loadMaterialsSchemeDetailListDataApi(data) {
  return request({
    url: 'web/materialsScheme/listDetailData',
    method: 'post',
    data
  })
}

// 查询待进行后续业务处理的方案数量
export function countTodoApi(data) {
  return request({
    url: 'web/materialsScheme/countTodo',
    method: 'post',
    data
  })
}

// 获取方案委外服务明细
export function initSchemeServiceItemsApi(data) {
  return request({
    url: 'web/materialsScheme/initSchemeServiceItems',
    method: 'post',
    data
  })
}

// 根据方案ID查询活动信息
export function findActivityInfoBySchemeIdApi(data) {
  return request({
    url: 'web/materialsScheme/findActivityInfoBySchemeId',
    method: 'post',
    data
  })
}

// 根据方案ID查询活动物资服务使用信息
export function findActivityItemInfoBySchemeIdApi(data) {
  return request({
    url: 'web/materialsScheme/findActivityItemInfoBySchemeId',
    method: 'post',
    data
  })
}

// 获取方案活动结束执行情况明细信息
export function loadSchemeExecuteCaseDetailApi(data) {
  return request({
    url: 'web/materialsScheme/loadExecuteCaseDetail',
    method: 'post',
    data
  })
}

// 导出付款申请表
export function exportPayApplyDocApi(data) {
  return request({
    url: 'web/materialsScheme/exportPayApplyDoc',
    method: 'post',
    data
  })
}

// 根据方案ID查询派工签到统计信息
export function findDispatchSignStatisticsBySchemeIdApi(data) {
  return request({
    url: 'web/materialsScheme/findDispatchSignStatisticsBySchemeId',
    method: 'post',
    data
  })
}

// 导出痕迹化图片PDF
export function loadMaterialsSchemeTracePicPDFExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportTracePicPDF',
    method: 'post',
    data
  })
}

// 导出人员身份证图片PDF
export function loadMaterialsSchemeEmployeePicPDFExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportEmployeePicPDF',
    method: 'post',
    data
  })
}

// 导出人员考勤表xlsx
export function loadMaterialsSchemeEmployeeWorkDayXlsxExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportEmployeeWorkDayXlsx',
    method: 'post',
    data
  })
}

// 导出人员培训表xlsx
export function loadMaterialsSchemeExternalEmployeeTrainingTableXlsxExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportExternalEmployeeTrainingTable',
    method: 'post',
    data
  })
}

// 服务明细列表(主数据列表)
export function loadMaterialsSchemeServiceItemListDataApi(data) {
  return request({
    url: 'web/materialsScheme/listServiceItemData',
    method: 'post',
    data
  })
}

// 服务明细导出列表(主数据列表)
export function loadMaterialsSchemeServiceItemExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportServiceItemData',
    method: 'post',
    data
  })
}
// 执行标准列表(主数据列表)
export function loadMaterialsSchemeRuleListDataApi(data) {
  return request({
    url: 'web/materialsScheme/listRuleData',
    method: 'post',
    data
  })
}

// 执行标准导出列表(主数据列表)
export function loadMaterialsSchemeRuleExportDataApi(data) {
  return request({
    url: 'web/materialsScheme/exportRuleData',
    method: 'post',
    data
  })
}

// 下拉
export function materialsSchemeRuleListSelectDataApi(data) {
  return request({
    url: 'web/materialsScheme/listRuleSelectData',
    method: 'post',
    data
  })
}

// 根据执行标准主键查询标准信息
export function findMaterialsSchemeRuleByRuleIdApi(data) {
  return request({
    url: 'web/materialsScheme/findSchemeRuleByRuleId',
    method: 'post',
    data
  })
}

// 根据条件查询执行标准条数
export function findSchemeRuleCountByConditionApi(data) {
  return request({
    url: 'web/materialsScheme/findSchemeRuleCountByCondition',
    method: 'post',
    data
  })
}
